<template>
    <div v-if="hasOffers">
        <div class="te-cart-heading">{{languageSettings.offer}}</div>
        <ul class="te-cart-offers">
            <li v-for="offer in offers" :key="offer.id" class="te-cart-offer">
                <div class="te-cart-offer-name">{{offer.name}}</div>
                <div class="te-cart-offer-price">{{getFormattedPrice(offer.currency, offer.price)}}</div>
                <div class="te-cart-offer-action">
                    <button name="add-to-cart" class="te-button te-primary-action" @click="onAddToCart(offer)">{{languageSettings.addToCart}}</button>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import format from '../services/format'

    export default {
        name: "Offers",

        props: {
            language: {
                type: Object
            },
        },

        computed: {
            ...mapGetters({
                offers: 'offers',
            }),

            languageSettings: function() {
                const defaultSettings = {
                    offer: 'You might also want',
                    addToCart: 'Add to cart',
                };
                return Object.assign(defaultSettings, this.language);
            },

            hasOffers: function () {
                return this.offers && this.offers.length > 0;
            },
        },

        methods: {
            ...mapActions([
                "acceptOffer",
            ]),

            getFormattedPrice(currency, price) {
                return format.price(currency, price);
            },

            onAddToCart(offer) {
                this.acceptOffer({offerId: offer.id});
            },

        },
    }
</script>

<style scoped>

</style>
